<template lang="pug">
  .part.part-2
    .game__title
      p 食指蓋住#[span 後鏡頭]#[br]讀取心跳脈搏
    .game__icon
    .game__count
      p 準備開始囉！
      span {{ count }}
    //- .game__button.game__button-capture(@click.prevent="changePart(3)")
    //-   .game__button__camera
</template>

<script>
import { mapState, mapActions } from 'vuex'
import { mixins } from '@/utils/mixins'

export default {
  name: 'GamePart2',
  mixins: [mixins],
  props: {
    changePart: Function,
    isRecording: Boolean,
  },
  watch: {
    isRecording(newValue) {
      const { startCountdown, cancelCountdown } = this;
      if (newValue) {
        startCountdown()
      } else {
        cancelCountdown();
      }
    },
  },
  data: () => {
    return {
      count: 5,
      timer: null,
    }
  },
  computed: {
    ...mapState([])
  },
  methods: {
    ...mapActions([]),
    startCountdown() {
      const { changePart } = this;
      this.timer = setInterval(() => {
        this.count = this.count - 1;
        if (this.count === 0) {
          this.cancelCountdown();
          changePart(3);
        }
      }, 1000)
    },
    cancelCountdown() {
      clearInterval(this.timer);
    },
  },
  mounted() {
    if (this.isDev()) this.count = 3;
    this.$nextTick(() => {
      if(this.isRecording) this.startCountdown();
    })
  },
  components: {
  },
  destroyed() {
    const { cancelCountdown } = this;
    cancelCountdown();
  },
}
</script>

<style lang="scss">

$assets: '~@/assets/images/game/part-2/';

#game .part-2 {

  .game__title {
    position: absolute;
    top: vw(222);
    left: 0;
    width: 100%;
    p {
      font-size: vw(36);
      text-align: center;
      letter-spacing: vw(letterSpacing(500, 36));
      line-height: lineHeight(36, 60);
      @include narrow-text;
      @include neon-text;
    }

    span {
      color: #ff85f5;
      // color: #ff60f2;
      font-size: vw(48);
    }
  }

  .game__icon {
    position: absolute;
    top: vw(453);
    left: vw(308);
    width: vw(211);
    height: vw(217);
    background: url($assets + 'icon-hint.png') no-repeat 0 0 / contain;

    &::before {
      content: '';
      position: absolute;
      top: vw(30);
      left: vw(30);
      width: vw(10);
      height: vw(10);
      border-radius: 100%;
      background: #ff60f2;
      box-shadow:
        rgba(#ff47bc, .5) 0 0 .15em,
        rgba(#ff47bc, .5) 0 0 .3em,
        rgba(#ff47bc, .5) 0 0 .45em;
      animation: gameIconHint 1.5s ease-in-out infinite;
    }

    &::after {
      content: '';
      position: absolute;
      top: vw(29);
      left: vw(27);
      width: vw(184);
      height: vw(181);
      background: url($assets + 'icon-hint-finger.png') no-repeat 0 0 / contain;
      animation: gameIconFinger 2s ease-in-out infinite;
    }

    @keyframes gameIconHint {
      0%, 100% { opacity: 0; }
      50% { opacity: 1; }
    }

    @keyframes gameIconFinger {
      0%, 100% {
        transform: translate(0, 0);
      }
      50% {
        transform: translate(15%, 4%);
      }
    }
  }

  .game__count {
    position: absolute;
    top: vw(1088);
    left: 0;
    width: 100%;
    p {
      font-size: vw(30);
      text-align: center;
      line-height: 1;
      letter-spacing: vw(letterSpacing(500, 30));
      text-indent: vw(58);
      @include narrow-text;
      margin-bottom: vw(12);
    }
    span {
      display: block;
      font-size: vw(36);
      font-weight: 900;
      text-align: center;
      line-height: 1;
      @include narrow-text;
    }
  }

}

</style>
